module.exports = __webpack_public_path__ + "img/bcc002.d97219f5.jpeg";